<template>
  <div>
    <span @click="modal = true">
      <slot></slot>
    </span>

    <modal @close="modal = false" :open="modal" :maxWitdh="'600px'">
      
      <div class="ar-card">
        <div class="ar-card-header">
          <div class="ar-card-title">
            افزودن کیف پول تتر 
          </div>
          <span>
            <i @click="modal = false" class="mdi mdi-close"></i>
          </span>
        </div>
        <div class="ar-card-body text-right">
          
          <div class="d-flex flex-column justify-content-center align-items-center">
            <img class="m-auto" style="height:100px;" :src="StaticImageUrl+'assets/images/icon/USDT.png'">
            <h3>USDT</h3>
          </div>
          
          <div class="ar-form-group">
            <label>شبکه</label>
            <select class="ar-form-control text-left font-en" v-model="wallet.network">
              <option value="TRC20">TRC20</option>
              <option value="ERC20">ERC20</option>
              <option value="BEP20">BEP20</option>
              <option value="BEP2">BEP2</option>
            </select>
            <div v-if="errors.network" class="ar-form-text">
              <small>{{errors.network[0]}}</small>
            </div>
          </div>
          
          <div class="ar-form-group">
            ممو <input v-model="has_memo" type="checkbox"/>
          </div>
          
          <div v-if="has_memo" class="ar-form-group">
            <label>تگ یا ممو</label>
            <input class="ar-form-control text-left latin-input-2" v-model="wallet.tag" />
            <div v-if="errors.tag" class="ar-form-text">
              <small>{{errors.tag[0]}}</small>
            </div>
          </div>
          
          <div class="ar-form-group">
            <label>آدرس</label>
            <input class="ar-form-control text-left latin-input-2" v-model="wallet.address">
            <div v-if="errors.address" class="ar-form-text">
              <small>{{errors.address[0]}}</small>
            </div>
          </div>

          <small class="text-primary-dark">
            <i class="mdi mdi-checkbox-blank-circle" style="position:relative;top:4px;"></i>
            مسئولیت وارد کردن کیف پول به عهده کاربر می باشد. لطفا در وارد کردن کیف پول دقت کنید.
          </small>
          
        </div>
        <div class="ar-card-footer">
          <button @click="addWallet()" class="ar-btn size-sm primary">ثبت</button>
          <button @click="modal = false" class="ar-btn size-sm outline-primary mx-3">انصراف</button>
        </div>
      </div>

    </modal>

  </div>
</template>
<script>
import Modal from './Modal.vue'
import {TheMask} from 'vue-the-mask'
import {io} from 'socket.io-client';
export default {
  name: 'AddBankAccount',
  components:{
    Modal,
    TheMask
  },
  props:{
  },
  data : () => ({
    modal:false,
    has_memo:false,
    wallet:{
      network:'TRC20'
    },
    errors:{},
    socket : null,
  }),
  watch:{
    
  },
  methods:{
    addWallet (){
      this.wallet.crypto_symbol = 'USDT'
      this.activeLoading(true)
      const api_token = this.getToken()
      this.$axios.post(`addWallet` , this.wallet,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.StoreWallets(res.data.data)
        this.activeLoading(false)
        this.errors = {}
        this.wallet = {}
        this.socket.emit('admin_notification');
        this.modal = false
        this.$notify({
          group: 'foo',
          type: 'success',
          duration: 5000,
          text: 'کیف پول با موفقیت ثبت شد.'
        });
      })
      .catch(err => {
        this.activeLoading(false)
        this.errors = err.response.data.errors
      });

    },
  },
  computed:{
  },
  mounted() {
    this.socket = io(this.socketUrl);
    
  }
}
</script>